import { WizardStep } from "@/modes/mode";
import { selectIpxEstimatedRegionBytes } from "@/store/modes/ipx-order-mode-selectors";
import { setIpxCheckout } from "@/store/modes/ipx-order-mode-slice";
import { humanReadableBytes } from "@faro-lotv/foundation";
import { IPX_MOCK_SIZE_LIMIT_BYTES } from "./ipx-config";
import { DefineAreaPanel } from "./steps/define-area-step";
import { OrderPlacedPanel } from "./steps/order-placed-step";
import { ReviewPanel } from "./steps/review-step";

/** Keys of the steps of the IPX ordering wizard */
export enum IpxOrderStepKey {
  defineArea = "defineArea",
  review = "review",
  placed = "placed",
}

export const IPX_ORDER_STEPS: WizardStep[] = [
  {
    key: IpxOrderStepKey.defineArea,
    label: "Define volume",
    instructions:
      "Select a point cloud, or only some of its groups and scans, then fit the box around the part of the building you need. IPX receives what you see in the view.",
    hint: "Drag the box handles to fit the volume you need",
    isCanvasFocused: true,
    Panel: DefineAreaPanel,
    selectCanContinue: (state) => {
      if (!state.ipxOrderMode.pointCloudId) return "Select a dataset.";
      const bytes = selectIpxEstimatedRegionBytes(state);
      if (bytes === undefined) return "Loading the point cloud…";
      // Until then, the size and the area are the ones of the last region
      if (state.ipxOrderMode.floorEstimate?.status === "computing") {
        return "Estimating the floor area…";
      }
      if (bytes > IPX_MOCK_SIZE_LIMIT_BYTES) {
        return `The selected data is about ${humanReadableBytes(bytes, 1)}, IPX accepts up to ${humanReadableBytes(IPX_MOCK_SIZE_LIMIT_BYTES)}. Make the box smaller or remove scans.`;
      }
      return true;
    },
  },
  {
    key: IpxOrderStepKey.review,
    label: "Review",
    instructions:
      "Check what you send to Integrated Projects (IPX). In the IPX checkout you choose floor plans or BIM models, accept the IPX terms and pay IPX.",
    Panel: ReviewPanel,
    primaryActionLabel: "Continue to IPX checkout",
    onPrimaryAction({ dispatch }) {
      dispatch(setIpxCheckout("open"));
      return Promise.resolve();
    },
  },
  {
    key: IpxOrderStepKey.placed,
    label: "Order placed",
    instructions:
      "Your order was placed and paid at IPX. Follow its status in Cloud activity, the results are added to this project once IPX delivers them.",
    Panel: OrderPlacedPanel,
    primaryActionLabel: "Finish",
    preventBack: true,
    selectCanContinue: (state) =>
      !!state.ipxOrderMode.order || "The order has not been placed.",
  },
];
